import { createSelector } from '@reduxjs/toolkit'

import { selectWorkspaceId } from '../utils/selectIds'
import { selectDashboard } from './selectDashboard'

export const getActiveWorkspace = createSelector(
  [selectDashboard, selectWorkspaceId],
  (dashboard, workspaceId) => {
    if (!workspaceId) {
      return (
        dashboard.find((workspace) => workspace.type === 'personal') || null
      )
    }

    return dashboard.find((w) => w.id === workspaceId) || null
  }
)
